<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <button onclick="javascript:location.href='../UIC/Province'" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
      </div>
      <div class="card-body">
        <table class="table table-sm table-bordered" id="myTable">
          <thead class="bg-custom">
            <tr>
              <th>Sr.</th>
              <th>Province Name</th>
              <th>Country Name</th>
              <th>Active</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, ind) in list" :key="ind">
              <td>{{ ind + 1 }}</td>
              <td>{{ item.PVN_NAME }}</td>
              <td>{{ item.C_NAME }}</td>
              <td><input type="checkbox" :checked="item.PVN_ISACTIVE === 'Y'" disabled></td>
              <td>
                <button class="btn btn-primary btn-sm" @click="editprovince(item.PVN_ID)"><i class="fas fa-pencil-alt" /></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    data() {
      return {
        list: [],
      };
    },

    created() {
      this.pageload();
    },
    updated() {
      $("#myTable").DataTable();
    },
    methods: {
      pageload() {
        var vm = this;
        startReq();
        axios.get('/api/UICApi/pageLoadProvinceList')
          .then((res) => {
            endReq();
            if (res.data.status) {
              vm.list = res.data.list;
            } else {
              toastr.error(res.data.msg);
            }
          })
          .catch((error) => {
            endReq();
          });
      },
      editprovince(id) {
        window.open("/UIC/Province?id=" + id);
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ims/ProvinceList.vue